import { render, staticRenderFns } from "./ModelsPage.vue?vue&type=template&id=2444bb38&scoped=true"
import script from "./ModelsPage.vue?vue&type=script&lang=js"
export * from "./ModelsPage.vue?vue&type=script&lang=js"
import style0 from "./ModelsPage.vue?vue&type=style&index=0&id=2444bb38&prod&lang=css"
import style1 from "./ModelsPage.vue?vue&type=style&index=1&id=2444bb38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2444bb38",
  null
  
)

export default component.exports